const CREDIT_CHECK_VISITED_KEY = 'de_credit_check_visited';

export function markCreditCheckVisited(): void {
  try {
    sessionStorage.setItem(CREDIT_CHECK_VISITED_KEY, 'true');
  } catch {
    // sessionStorage unavailable (e.g. private mode) — best-effort
  }
}

export function hasVisitedCreditCheck(): boolean {
  try {
    return sessionStorage.getItem(CREDIT_CHECK_VISITED_KEY) === 'true';
  } catch {
    return false;
  }
}

export function clearCreditCheckVisited(): void {
  try {
    sessionStorage.removeItem(CREDIT_CHECK_VISITED_KEY);
  } catch {
    // best-effort
  }
}
